import { ChangeDetectorRef, Component, Input, OnChanges, ViewEncapsulation } from '@angular/core';

import { LucideIconData } from 'lucide-angular';

import { LucideIconLoaderService } from './lucide-icon-loader.service';

/**
 * Icono de lucide que también funciona con nombres fuera del catálogo.
 *
 * Reemplaza a `<lucide-icon>` donde el nombre lo elige el usuario y no el
 * código: los iconos de los menús, que se pueden escribir a mano. Si el nombre
 * está en el catálogo se dibuja directo, igual que antes; si no, se pide al
 * set completo y se pasa por `[img]`, que es la entrada de lucide para datos
 * de icono ya resueltos.
 *
 * En los selectores y en los iconos fijos del código conviene seguir usando
 * `<lucide-icon>`: ahí el nombre siempre sale del catálogo y no hace falta el
 * rodeo.
 */
@Component({
  selector: 'app-lucide-icon',
  template: `
    <lucide-icon *ngIf="bundled" [name]="name" [size]="size"></lucide-icon>
    <lucide-icon *ngIf="!bundled && img" [img]="img" [size]="size"></lucide-icon>
  `,
  styles: [`
    app-lucide-icon,
    app-lucide-icon lucide-icon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex: 0 0 auto;
    }
  `],
  // Sin encapsular: así las pantallas que ya estilan el icono por su clase
  // (tamaño de caja, color) le siguen pegando igual que a <lucide-icon>
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class AppLucideIconComponent implements OnChanges {

  /** Nombre del icono en kebab ('square-pen'), esté o no en el catálogo */
  @Input() name?: string;

  /** Tamaño en px; se delega tal cual a lucide */
  @Input() size?: number;

  /** El nombre viene empaquetado: se dibuja sin ir a buscar nada */
  bundled = false;

  /** Datos del icono traído del set completo, cuando no está en el catálogo */
  img: LucideIconData | null = null;

  constructor(
    private _loader: LucideIconLoaderService,
    private _cdr: ChangeDetectorRef
  ) { }

  ngOnChanges(): void {
    this.bundled = this._loader.isBundled(this.name);
    this.img = null;
    if (this.bundled || !this.name) return;

    // El nombre puede no existir en lucide (alguien escribió cualquier cosa):
    // en ese caso load() devuelve null y no se dibuja nada, sin romper la vista
    this._loader.load(this.name).then(icon => {
      this.img = icon;
      this._cdr.markForCheck();
    });
  }
}
